import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormFileUpload from '../general-input-form/FormFileUpload'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormFileThumbnail from '../general-input-form/FormFileThumbnail'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormPassengers from '../general-input-form/FormPassenger'

const AppForm = ({
  values,
  handleChange,
  onDateChange,
  handleFileInput,
  errors,
  handleConfirmDelete,
  projectOptions,
  handleSelectProject,
  projectValue,
  expenseIntervalOptions,
  handleSelectInterval,
  intervalValue,
  handleSwitchRepeatForever,
  handleViewFile,
  expenseCategoryOptions,
  expenseCategoryValue,
  expenseTagsOptions,
  handleSelectExpenseCategory,
  handleChangeFieldCategory,
  handleOnDateChangeCategory,
  expenseTransportationOptions,
  expenseTransportationValue,
  expenseFuelOptions,
  expenseFuelValue,
  handleSelectOptionExpenseCategory,
  tripTypeOptions,
  bookingThroughFlighOptions,
  bookingThroughTrainOptions,
  expenseFlightValue,
  expenseTrainValue,
  handleChangePassenger,
  handleRemovePassenger,
  handleAddPassenger,
  expenseAirplaneOptions,
  expenseAirplaneValue,
  bookingThroughAccomodationOptions,
  expenseAccomodationValue,
  provinceOptions,
  cityOptions,
  expenseAccomodationProvinceValue,
  expenseAccomodationCitiesValue,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='expense_name'
          name='expense_name'
          colSize='6'
          inputLabel='Expense Name'
          className='mb-3'
          placeholder='Enter expense name...'
          value={values.expense_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.expense_name}
          invalid={errors?.expense_name}
        />
        <FormPrice
          id='expense_value'
          name='expense_value'
          colSize='6'
          className='mb-3'
          inputLabel='Expense Value'
          placeholder='Enter expense value...'
          value={values.expense_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors?.expense_value}
          invalid={errors?.expense_value}
        />
        <FormTextAreaInput
          id='expense_description'
          name='expense_description'
          colSize='6'
          inputLabel='Expense Description'
          className='mb-3'
          placeholder='Enter expense description...'
          rows='6'
          value={values.expense_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.expense_description}
          invalid={errors?.expense_description}
        />
        {
          (!values?.expense_repeat_interval || values?.expense_repeat_interval === 'no repeat') && (
            <FormDatePicker 
              id='expense_date'
              name='expense_date'
              colSize='6'
              inputLabel='Expense Date'
              className='mb-3'
              handleOnDateChange={onDateChange}
              value={values.expense_date}
              feedbackInvalid={errors?.expense_date}
              invalid={errors?.expense_date}
              disabled={values?.expense_repeat_interval && values?.expense_repeat_interval !== 'no repeat'}
            />
          )
        }
        {
          (!values?.expense_repeat_interval || values?.expense_repeat_interval !== 'no repeat') && (
            <FormSwitchInput 
              id='expense_repeat_forever'
              name='expense_repeat_forever'
              colSize='6'
              inputLabel='Expense Repeat Forever'
              className='mb-3'
              handleSwitch={handleSwitchRepeatForever}
              value={values.expense_repeat_forever}
              invalid={errors?.expense_repeat_forever}
            />
          )
        }
        <FormSelectInput 
          id='expense_repeat_interval'
          name='expense_repeat_interval'
          colSize='6'
          inputLabel='Expense Repeat Interval'
          className='mb-3'
          selectOptions={expenseIntervalOptions}
          value={intervalValue}
          handleSelectInput={handleSelectInterval}
          feedbackInvalid={errors.expense_repeat_interval}
          invalid={errors.expense_repeat_interval}
          disabled={false}
          isClearable={false}
        />
        {
          values?.expense_repeat_interval !== 'no repeat' && (
            <FormDatePicker 
              id='expense_repeat_start_date'
              name='expense_repeat_start_date'
              colSize='6'
              inputLabel='Expense Start Date'
              className='mb-3'
              handleOnDateChange={onDateChange}
              value={values.expense_repeat_start_date}
              feedbackInvalid={errors?.expense_repeat_start_date}
              invalid={errors?.expense_repeat_start_date}
              disabled={values?.expense_repeat_interval == 'no repeat'}
            />
          )
        }
        {
          !values?.expense_repeat_forever && values?.expense_repeat_interval !== 'no repeat' && (
            <FormDatePicker 
              id='expense_repeat_end_date'
              name='expense_repeat_end_date'
              colSize='6'
              inputLabel='Expense End Date'
              className='mb-3'
              handleOnDateChange={onDateChange}
              value={values.expense_repeat_end_date}
              feedbackInvalid={!values.expense_repeat_forever && errors?.expense_repeat_end_date}
              invalid={!values.expense_repeat_forever && errors?.expense_repeat_end_date}
              disabled={values?.expense_repeat_forever || values?.expense_repeat_interval == 'no repeat'}
            />
          )
        }
        {
          values?.file?.length > 0 ? (
            <CCol lg={6}>
              <CFormLabel>
                Document Attachment
              </CFormLabel>
              <FormFileThumbnail 
                name='expense_file'
                colSize='12'
                files={values?.file}
                className='justify-content-start align-items-center'
                handleConfirmDelete={handleConfirmDelete}
                handleViewFile={handleViewFile}
              />
            </CCol>
          )
          : (
            <FormFileUpload
              name='expense'
              colSize='6'
              handleFileInput={handleFileInput}
              handleFileOnDrop={handleFileInput}
              inputLabel='Document Attachment'
              multiple={false}
              feedbackInvalid={errors?.file}
              invalid={errors?.file}
              isSpesificImage={false}
              maxFiles={1}
            />
          )
        }
        <FormTextAreaInput
          id='expense_notes'
          name='expense_notes'
          colSize='6'
          inputLabel='Expense Notes'
          className='mb-3'
          placeholder='Enter expense notes...'
          rows='3'
          value={values.expense_notes}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.expense_notes}
          invalid={errors?.expense_notes}
        />
        <FormSelectInput 
          id='category_id'
          name='category_id'
          colSize='6'
          className='mb-3'
          inputLabel='Category'
          selectOptions={expenseCategoryOptions}
          value={expenseCategoryValue}
          handleSelectInput={handleSelectExpenseCategory}
          feedbackInvalid={errors.category_id}
          invalid={errors.category_id}
          disabled={false}
        />
        {
          values.is_related_to_project !== null && (
            <>
              <FormSwitchInput 
                id='is_related_to_project'
                name='is_related_to_project'
                colSize='3'
                inputLabel='Related to project?'
                className='mb-3'
                handleSwitch={handleChange}
                value={values.is_related_to_project}
                invalid={errors?.is_related_to_project}
              />
              {
                values?.is_related_to_project && (
                  <FormSelectInput 
                    id='project_id'
                    name='project_id'
                    colSize='3'
                    className='mb-3'
                    inputLabel='Project Name'
                    selectOptions={projectOptions}
                    value={projectValue}
                    handleSelectInput={handleSelectProject}
                    feedbackInvalid={errors.project_id}
                    invalid={errors.project_id}
                    disabled={false}
                  />
                )
              }
            </>
          )
        }
      </CRow>
      {
        values?.category_value?.label == 'Flight' && (
          <CRow>
            <FormTextInput 
              id='reservation_number'
              name='reservation_number'
              colSize='6'
              inputLabel='Reservation number'
              className='mb-3'
              placeholder='Enter reservation number...'
              value={values?.expense_flight?.reservation_number}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_flight')}
              feedbackInvalid={errors?.expense_flight?.reservation_number}
              invalid={errors?.expense_flight?.reservation_number}
            />
            <FormSelectInput 
              id='airplane_name'
              name='airplane_name'
              colSize='6'
              className='mb-3'
              inputLabel='Airplane name'
              selectOptions={expenseAirplaneOptions}
              value={expenseAirplaneValue}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'airplane_name', 'expense_flight', false)}
              feedbackInvalid={errors.expense_flight?.airplane_name}
              invalid={errors.expense_flight?.airplane_name}
              disabled={false}
            />
            <FormTextInput 
              id='flight_details'
              name='flight_details'
              colSize='6'
              inputLabel='Flight detail'
              className='mb-3'
              placeholder='Enter flight detail...'
              value={values?.expense_flight?.flight_details}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_flight')}
              feedbackInvalid={errors?.expense_flight?.flight_details}
              invalid={errors?.expense_flight?.flight_details}
            />
            <FormSelectInput 
              id='flight_type'
              name='flight_type'
              colSize='6'
              className='mb-3'
              inputLabel='Flight type'
              selectOptions={tripTypeOptions}
              value={tripTypeOptions?.filter((val) => val?.value == values?.expense_flight?.flight_type)[0]}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'flight_type', 'expense_flight', false)}
              feedbackInvalid={errors.expense_flight?.flight_type}
              invalid={errors.expense_flight?.flight_type}
              disabled={false}
            />
            {
              (values?.expense_flight.booking_through == '' || values?.expense_flight.booking_through !== 'Others') ? (
                <FormSelectInput 
                  id='booking_through'
                  name='booking_through'
                  colSize='6'
                  className='mb-3'
                  inputLabel='Booking through'
                  selectOptions={bookingThroughFlighOptions}
                  value={expenseFlightValue}
                  handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_flight', false)}
                  feedbackInvalid={errors.expense_flight?.booking_through}
                  invalid={errors.expense_flight?.booking_through}
                  disabled={false}
                />
              ) : (
                <CCol lg={6}>
                  <FormSelectInput 
                    id='booking_through'
                    name='booking_through'
                    colSize='12'
                    className='mb-3'
                    inputLabel='Booking through'
                    selectOptions={bookingThroughFlighOptions}
                    value={expenseFlightValue}
                    handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_flight', false)}
                    feedbackInvalid={errors.expense_flight?.booking_through}
                    invalid={errors.expense_flight?.booking_through}
                    disabled={false}
                  />
                  <FormTextInput 
                    id='other_booking_input'
                    name='other_booking_input'
                    colSize='12'
                    className='mb-3'
                    placeholder='Please input description...'
                    value={values?.expense_flight?.other_booking_input}
                    handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_flight')}
                    feedbackInvalid={errors?.expense_flight?.other_booking_input}
                    invalid={errors?.expense_flight?.other_booking_input}
                  />
                </CCol>
              )
            }
            <FormDatePicker 
              id='reservation_date_1'
              name='reservation_date_1'
              colSize='6'
              inputLabel={values?.expense_flight?.flight_type == 'One way' || values?.expense_flight?.flight_type == '' ? 'Flight date' : 'Flight departure date'}
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_flight')}
              value={values?.expense_flight?.reservation_date_1}
              feedbackInvalid={errors?.expense_flight?.reservation_date_1}
              invalid={errors?.expense_flight?.reservation_date_1}
            />
            {
              values?.expense_flight?.flight_type == 'Return' && (
                <FormDatePicker 
                  id='reservation_date_2'
                  name='reservation_date_2'
                  colSize='6'
                  inputLabel='Flight return date'
                  className='mb-3'
                  handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_flight')}
                  value={values?.expense_flight?.reservation_date_2}
                  feedbackInvalid={errors?.expense_flight?.reservation_date_2}
                  invalid={errors?.expense_flight?.reservation_date_2}
                />
              )
            }
            <FormPassengers 
              type={'flight'}
              colSize="12"
              inputLabel="Passengers"
              className="mb-3"
              passengers={values?.expense_flight?.passengers}
              handleAddPassenger={() => handleAddPassenger('expense_flight')}
              errors={errors}
              handleChange={(e, index) => handleChangePassenger(e, index, 'expense_flight')}
              handleRemovePassenger={(index) => handleRemovePassenger(index, 'expense_flight')}
              isDetail={false}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Accomodation' && (
          <CRow>
            <FormTextInput 
              id='reservation_number'
              name='reservation_number'
              colSize='6'
              inputLabel='Reservation number'
              className='mb-3'
              placeholder='Enter reservation number...'
              value={values?.expense_accomodation?.reservation_number}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
              feedbackInvalid={errors?.expense_accomodation?.reservation_number}
              invalid={errors?.expense_accomodation?.reservation_number}
            />
            <FormTextInput 
              id='accomodation_name'
              name='accomodation_name'
              colSize='6'
              inputLabel='Accomodation name'
              className='mb-3'
              placeholder='Enter accomodation name...'
              value={values?.expense_accomodation?.accomodation_name}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
              feedbackInvalid={errors?.expense_accomodation?.accomodation_name}
              invalid={errors?.expense_accomodation?.accomodation_name}
            />
            <FormTextInput 
              id='accomodation_details'
              name='accomodation_details'
              colSize='6'
              inputLabel='Accomodation detail'
              className='mb-3'
              placeholder='Enter accomodation detail...'
              value={values?.expense_accomodation?.accomodation_details}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
              feedbackInvalid={errors?.expense_accomodation?.accomodation_details}
              invalid={errors?.expense_accomodation?.accomodation_details}
            />
            <FormTextAreaInput
              id='accomodation_address'
              name='accomodation_address'
              colSize='6'
              inputLabel='Accomodation address'
              className='mb-3'
              placeholder='Enter address...'
              rows='6'
              value={values?.expense_accomodation?.accomodation_address}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
              feedbackInvalid={errors?.expense_accomodation?.accomodation_address}
              invalid={errors?.expense_accomodation?.accomodation_address}
            />
            <FormSelectInput 
              id='accomodation_province_id'
              name='accomodation_province_id'
              colSize='6'
              className='mb-3'
              inputLabel='Province'
              selectOptions={provinceOptions}
              value={expenseAccomodationProvinceValue}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'accomodation_province_id', 'expense_accomodation', false)}
              feedbackInvalid={errors.expense_accomodation?.accomodation_province_id}
              invalid={errors.expense_accomodation?.accomodation_province_id}
              disabled={false}
            />
            <FormSelectInput 
              id='accomodation_city_id'
              name='accomodation_city_id'
              colSize='6'
              className='mb-3'
              inputLabel='City'
              selectOptions={cityOptions}
              value={expenseAccomodationCitiesValue}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'accomodation_city_id', 'expense_accomodation', false)}
              feedbackInvalid={errors.expense_accomodation?.accomodation_city_id}
              invalid={errors.expense_accomodation?.accomodation_city_id}
              disabled={false}
            />
            {
              (values?.expense_accomodation.booking_through == '' || values?.expense_accomodation.booking_through !== 'Others') ? (
                <FormSelectInput 
                  id='booking_through'
                  name='booking_through'
                  colSize='6'
                  className='mb-3'
                  inputLabel='Booking through'
                  selectOptions={bookingThroughAccomodationOptions}
                  value={expenseAccomodationValue}
                  handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_accomodation', false)}
                  feedbackInvalid={errors.expense_accomodation?.booking_through}
                  invalid={errors.expense_accomodation?.booking_through}
                  disabled={false}
                />
              ) : (
                <CCol lg={6}>
                  <FormSelectInput 
                    id='booking_through'
                    name='booking_through'
                    colSize='12'
                    className='mb-3'
                    inputLabel='Booking through'
                    selectOptions={bookingThroughAccomodationOptions}
                    value={expenseAccomodationValue}
                    handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_accomodation', false)}
                    feedbackInvalid={errors.expense_accomodation?.booking_through}
                    invalid={errors.expense_accomodation?.booking_through}
                    disabled={false}
                  />
                  <FormTextInput 
                    id='other_booking_input'
                    name='other_booking_input'
                    colSize='12'
                    className='mb-3'
                    placeholder='Please input description...'
                    value={values?.expense_accomodation?.other_booking_input}
                    handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
                    feedbackInvalid={errors?.expense_accomodation?.other_booking_input}
                    invalid={errors?.expense_accomodation?.other_booking_input}
                  />
                </CCol>
              )
            }
            <FormSwitchInput 
              id='is_booking_more_than_one_day'
              name='is_booking_more_than_one_day'
              colSize='6'
              inputLabel='More than one day?'
              className='mb-3'
              handleSwitch={(e) => handleChangeFieldCategory(e, 'expense_accomodation')}
              value={values?.expense_accomodation?.is_booking_more_than_one_day}
              invalid={errors?.expense_accomodation?.is_booking_more_than_one_day}
            />
            <FormDatePicker 
              id='reservation_date_1'
              name='reservation_date_1'
              colSize='6'
              inputLabel={values?.expense_accomodation?.is_booking_more_than_one_day ? 'Reservation start' : 'Reservation date'}
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_accomodation')}
              value={values?.expense_accomodation?.reservation_date_1}
              feedbackInvalid={errors?.expense_accomodation?.reservation_date_1}
              invalid={errors?.expense_accomodation?.reservation_date_1}
            />
            {
              values?.expense_accomodation?.is_booking_more_than_one_day && (
                <FormDatePicker 
                  id='reservation_date_2'
                  name='reservation_date_2'
                  colSize='6'
                  inputLabel='Reservation end'
                  className='mb-3'
                  handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_accomodation')}
                  value={values?.expense_accomodation?.reservation_date_2}
                  feedbackInvalid={errors?.expense_accomodation?.reservation_date_2}
                  invalid={errors?.expense_accomodation?.reservation_date_2}
                />
              )
            }
            <FormPassengers 
              type={'accomodation'}
              colSize="12"
              inputLabel="Guests"
              className="mb-3"
              passengers={values?.expense_accomodation?.guests}
              handleAddPassenger={() => handleAddPassenger('expense_accomodation')}
              errors={errors}
              handleChange={(e, index) => handleChangePassenger(e, index, 'expense_accomodation')}
              handleRemovePassenger={(index) => handleRemovePassenger(index, 'expense_accomodation')}
              isDetail={false}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Train' && (
          <CRow>
            <FormTextInput 
              id='reservation_number'
              name='reservation_number'
              colSize='6'
              inputLabel='Reservation number'
              className='mb-3'
              placeholder='Enter reservation number...'
              value={values?.expense_train?.reservation_number}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_train')}
              feedbackInvalid={errors?.expense_train?.reservation_number}
              invalid={errors?.expense_train?.reservation_number}
            />
            <FormTextInput 
              id='train_name'
              name='train_name'
              colSize='6'
              inputLabel='Train name'
              className='mb-3'
              placeholder='Enter train name...'
              value={values?.expense_train?.train_name}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_train')}
              feedbackInvalid={errors?.expense_train?.train_name}
              invalid={errors?.expense_train?.train_name}
            />
            <FormTextInput 
              id='train_details'
              name='train_details'
              colSize='6'
              inputLabel='Train detail'
              className='mb-3'
              placeholder='Enter train detail...'
              value={values?.expense_train?.train_details}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_train')}
              feedbackInvalid={errors?.expense_train?.train_details}
              invalid={errors?.expense_train?.train_details}
            />
            <FormSelectInput 
              id='train_type'
              name='train_type'
              colSize='6'
              className='mb-3'
              inputLabel='Train type'
              selectOptions={tripTypeOptions}
              value={tripTypeOptions?.filter((val) => val?.value == values?.expense_train?.train_type)[0]}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'train_type', 'expense_train', false)}
              feedbackInvalid={errors.expense_train?.train_type}
              invalid={errors.expense_train?.train_type}
              disabled={false}
            />
            {
              (values?.expense_train.booking_through == '' || values?.expense_train.booking_through !== 'Others') ? (
                <FormSelectInput 
                  id='booking_through'
                  name='booking_through'
                  colSize='6'
                  className='mb-3'
                  inputLabel='Booking through'
                  selectOptions={bookingThroughTrainOptions}
                  value={expenseTrainValue}
                  handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_train', false)}
                  feedbackInvalid={errors.expense_train?.booking_through}
                  invalid={errors.expense_train?.booking_through}
                  disabled={false}
                />
              ) : (
                <CCol lg={6}>
                  <FormSelectInput 
                    id='booking_through'
                    name='booking_through'
                    colSize='12'
                    className='mb-3'
                    inputLabel='Booking through'
                    selectOptions={bookingThroughTrainOptions}
                    value={expenseTrainValue}
                    handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'booking_through', 'expense_train', false)}
                    feedbackInvalid={errors.expense_train?.booking_through}
                    invalid={errors.expense_train?.booking_through}
                    disabled={false}
                  />
                  <FormTextInput 
                    id='other_booking_input'
                    name='other_booking_input'
                    colSize='12'
                    className='mb-3'
                    placeholder='Please input description...'
                    value={values?.expense_train?.other_booking_input}
                    handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_train')}
                    feedbackInvalid={errors?.expense_train?.other_booking_input}
                    invalid={errors?.expense_train?.other_booking_input}
                  />
                </CCol>
              )
            }
            <FormDatePicker 
              id='reservation_date_1'
              name='reservation_date_1'
              colSize='6'
              inputLabel={values?.expense_train?.train_type == 'One way' || values?.expense_train?.train_type == '' ? 'Train date' : 'Train depature date'}
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_train')}
              value={values?.expense_train?.reservation_date_1}
              feedbackInvalid={errors?.expense_train?.reservation_date_1}
              invalid={errors?.expense_train?.reservation_date_1}
            />
            {
              values?.expense_train?.train_type == 'Return' && (
                <FormDatePicker 
                  id='reservation_date_2'
                  name='reservation_date_2'
                  colSize='6'
                  inputLabel='Train return date'
                  className='mb-3'
                  handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_train')}
                  value={values?.expense_train?.reservation_date_2}
                  feedbackInvalid={errors?.expense_train?.reservation_date_2}
                  invalid={errors?.expense_train?.reservation_date_2}
                />
              )
            }
            <FormPassengers 
              type={'train'}
              colSize="12"
              inputLabel="Passengers"
              className="mb-3"
              passengers={values?.expense_train?.passengers}
              handleAddPassenger={() => handleAddPassenger('expense_train')}
              errors={errors}
              handleChange={(e, index) => handleChangePassenger(e, index, 'expense_train')}
              handleRemovePassenger={(index) => handleRemovePassenger(index, 'expense_train')}
              isDetail={false}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Car rental' && (
          <CRow>
            <FormTextInput 
              id='rental_company'
              name='rental_company'
              colSize='6'
              inputLabel='Rental company'
              className='mb-3'
              placeholder='Enter rental company name...'
              value={values?.expense_car_rental?.rental_company}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_car_rental')}
              feedbackInvalid={errors?.expense_car_rental?.rental_company}
              invalid={errors?.expense_car_rental?.rental_company}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_car_rental?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_car_rental')}
              feedbackInvalid={errors?.expense_car_rental?.description}
              invalid={errors?.expense_car_rental?.description}
            />
            <FormTextInput 
              id='car_type'
              name='car_type'
              colSize='6'
              inputLabel='Car type'
              className='mb-3'
              placeholder='Enter car type...'
              value={values?.expense_car_rental?.car_type}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_car_rental')}
              feedbackInvalid={errors?.expense_car_rental?.car_type}
              invalid={errors?.expense_car_rental?.car_type}
            />
            <FormSwitchInput 
              id='is_booking_more_than_one_day'
              name='is_booking_more_than_one_day'
              colSize='6'
              inputLabel='More than one day?'
              className='mb-3'
              handleSwitch={(e) => handleChangeFieldCategory(e, 'expense_car_rental')}
              value={values?.expense_car_rental?.is_booking_more_than_one_day}
              invalid={errors?.expense_car_rental?.is_booking_more_than_one_day}
            />
            <FormDatePicker 
              id='booking_start'
              name='booking_start'
              colSize='6'
              inputLabel={values?.expense_car_rental?.is_booking_more_than_one_day ? 'Booking start' : 'Booking period'}
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_car_rental')}
              value={values?.expense_car_rental?.booking_start}
              feedbackInvalid={errors?.expense_car_rental?.booking_start}
              invalid={errors?.expense_car_rental?.booking_start}
            />
            {
              values?.expense_car_rental?.is_booking_more_than_one_day && (
                <FormDatePicker 
                  id='booking_end'
                  name='booking_end'
                  colSize='6'
                  inputLabel='Booking end'
                  className='mb-3'
                  handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_car_rental')}
                  value={values?.expense_car_rental?.booking_end}
                  feedbackInvalid={errors?.expense_car_rental?.booking_end}
                  invalid={errors?.expense_car_rental?.booking_end}
                  minDate={ values?.expense_car_rental?.booking_start ? moment(values?.expense_car_rental?.booking_start).add(1, 'd') :  moment(new Date()) }
                />
              )
            }
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Pettycash & Operational' && (
          <CRow>
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_pettycash_operational')}
              value={values?.expense_pettycash_operational?.datetime}
              feedbackInvalid={errors?.expense_pettycash_operational?.datetime}
              invalid={errors?.expense_pettycash_operational?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_pettycash_operational?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_pettycash_operational')}
              feedbackInvalid={errors?.expense_pettycash_operational?.description}
              invalid={errors?.expense_pettycash_operational?.description}
            />
            <FormSelectInput 
              id='tags'
              name='tags'
              colSize='6'
              inputLabel='Tags'
              className='mb-3'
              selectOptions={expenseTagsOptions}
              value={values?.expense_pettycash_operational?.tags}
              handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'tags', 'expense_pettycash_operational', true)}
              feedbackInvalid={errors?.expense_pettycash_operational?.tags}
              invalid={errors?.expense_pettycash_operational?.tags}
              disabled={false}
              multiple={true}
              placeholder='Please add tag...'
              isCreatable={true}
              noOptionsMessageText="Pleasee add manual tag"
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Meals' && (
          <CRow>
            <FormTextInput 
              id='restaurant_name'
              name='restaurant_name'
              colSize='6'
              inputLabel='Restaurant'
              className='mb-3'
              placeholder='Enter restaurant name...'
              value={values?.expense_meals?.restaurant_name}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_meals')}
              feedbackInvalid={errors?.expense_meals?.restaurant_name}
              invalid={errors?.expense_meals?.restaurant_name}
            />
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_meals')}
              value={values?.expense_meals?.datetime}
              feedbackInvalid={errors?.expense_meals?.datetime}
              invalid={errors?.expense_meals?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_meals?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_meals')}
              feedbackInvalid={errors?.expense_meals?.description}
              invalid={errors?.expense_meals?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Fuel' && (
          <CRow>
            {
              (values?.expense_fuel.company_name == '' || values?.expense_fuel.company_name !== 'Others') ? (
                <FormSelectInput 
                  id='company_name'
                  name='company_name'
                  colSize='6'
                  className='mb-3'
                  inputLabel='Company'
                  selectOptions={expenseFuelOptions}
                  value={expenseFuelValue}
                  handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'company_name', 'expense_fuel', false)}
                  feedbackInvalid={errors.expense_fuel?.company_name}
                  invalid={errors.expense_fuel?.company_name}
                  disabled={false}
                />
              ) : (
                <CCol lg={6}>
                  <FormSelectInput 
                    id='company_name'
                    name='company_name'
                    colSize='12'
                    className='mb-3'
                    inputLabel='Company'
                    selectOptions={expenseFuelOptions}
                    value={expenseFuelValue}
                    handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'company_name', 'expense_fuel', false)}
                    feedbackInvalid={errors.expense_fuel?.company_name}
                    invalid={errors.expense_fuel?.company_name}
                    disabled={false}
                  />
                  <FormTextInput 
                    id='other_company_input'
                    name='other_company_input'
                    colSize='12'
                    className='mb-3'
                    placeholder='Please input description...'
                    value={values?.expense_fuel?.other_company_input}
                    handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_fuel')}
                    feedbackInvalid={errors?.expense_fuel?.other_company_input}
                    invalid={errors?.expense_fuel?.other_company_input}
                  />
                </CCol>
              )
            }
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_fuel')}
              value={values?.expense_fuel?.datetime}
              feedbackInvalid={errors?.expense_fuel?.datetime}
              invalid={errors?.expense_fuel?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_fuel?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_fuel')}
              feedbackInvalid={errors?.expense_fuel?.description}
              invalid={errors?.expense_fuel?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'E-toll money' && (
          <CRow>
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_etoll')}
              value={values?.expense_etoll?.datetime}
              feedbackInvalid={errors?.expense_etoll?.datetime}
              invalid={errors?.expense_etoll?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_etoll?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_etoll')}
              feedbackInvalid={errors?.expense_etoll?.description}
              invalid={errors?.expense_etoll?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Transportation' && (
          <CRow>
            {
              (values?.expense_transportation.transportation_category == '' || values?.expense_transportation.transportation_category !== 'Others') ? (
                <FormSelectInput 
                  id='transportation_category'
                  name='transportation_category'
                  colSize='6'
                  className='mb-3'
                  inputLabel='Transportation'
                  selectOptions={expenseTransportationOptions}
                  value={expenseTransportationValue}
                  handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'transportation_category', 'expense_transportation', false)}
                  feedbackInvalid={errors.expense_transportation?.transportation_category}
                  invalid={errors.expense_transportation?.transportation_category}
                  disabled={false}
                />
              ) : (
                <CCol lg={6}>
                  <FormSelectInput 
                    id='transportation_category'
                    name='transportation_category'
                    colSize='12'
                    className='mb-3'
                    inputLabel='Transportation'
                    selectOptions={expenseTransportationOptions}
                    value={expenseTransportationValue}
                    handleSelectInput={(e) => handleSelectOptionExpenseCategory(e, 'transportation_category', 'expense_transportation', false)}
                    feedbackInvalid={errors.expense_transportation?.transportation_category}
                    invalid={errors.expense_transportation?.transportation_category}
                    disabled={false}
                  />
                  <FormTextInput 
                    id='other_transportation_input'
                    name='other_transportation_input'
                    colSize='12'
                    className='mb-3'
                    placeholder='Please input description...'
                    value={values?.expense_transportation?.other_transportation_input}
                    handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_transportation')}
                    feedbackInvalid={errors?.expense_transportation?.other_transportation_input}
                    invalid={errors?.expense_transportation?.other_transportation_input}
                  />
                </CCol>
              )
            }
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_transportation')}
              value={values?.expense_transportation?.datetime}
              feedbackInvalid={errors?.expense_transportation?.datetime}
              invalid={errors?.expense_transportation?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_transportation?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_transportation')}
              feedbackInvalid={errors?.expense_transportation?.description}
              invalid={errors?.expense_transportation?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Office supply / stationery' && (
          <CRow>
            <FormTextInput 
              id='company'
              name='company'
              colSize='6'
              inputLabel='Company'
              className='mb-3'
              placeholder='Enter company name...'
              value={values?.expense_office_supplies?.company}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_office_supplies')}
              feedbackInvalid={errors?.expense_office_supplies?.company}
              invalid={errors?.expense_office_supplies?.company}
            />
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_office_supplies')}
              value={values?.expense_office_supplies?.datetime}
              feedbackInvalid={errors?.expense_office_supplies?.datetime}
              invalid={errors?.expense_office_supplies?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_office_supplies?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_office_supplies')}
              feedbackInvalid={errors?.expense_office_supplies?.description}
              invalid={errors?.expense_office_supplies?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Printing' && (
          <CRow>
            <FormTextInput 
              id='company'
              name='company'
              colSize='6'
              inputLabel='Company'
              className='mb-3'
              placeholder='Enter company name...'
              value={values?.expense_printing?.company}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_printing')}
              feedbackInvalid={errors?.expense_printing?.company}
              invalid={errors?.expense_printing?.company}
            />
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_printing')}
              value={values?.expense_printing?.datetime}
              feedbackInvalid={errors?.expense_printing?.datetime}
              invalid={errors?.expense_printing?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_printing?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_printing')}
              feedbackInvalid={errors?.expense_printing?.description}
              invalid={errors?.expense_printing?.description}
            />
          </CRow>
        )
      }
      {
        values?.category_value?.label == 'Other reimbursement' && (
          <CRow>
            <FormTextInput 
              id='reimbursement_for'
              name='reimbursement_for'
              colSize='6'
              inputLabel='Reimbursement for'
              className='mb-3'
              placeholder='Enter reimbursement for...'
              value={values?.expense_other_reimbursement?.reimbursement_for}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_other_reimbursement')}
              feedbackInvalid={errors?.expense_other_reimbursement?.reimbursement_for}
              invalid={errors?.expense_other_reimbursement?.reimbursement_for}
            />
            <FormTextInput 
              id='company'
              name='company'
              colSize='6'
              inputLabel='Company'
              className='mb-3'
              placeholder='Enter company name...'
              value={values?.expense_other_reimbursement?.company}
              handleTextInput={(e) => handleChangeFieldCategory(e, 'expense_other_reimbursement')}
              feedbackInvalid={errors?.expense_other_reimbursement?.company}
              invalid={errors?.expense_other_reimbursement?.company}
            />
            <FormDatePicker 
              id='datetime'
              name='datetime'
              colSize='6'
              inputLabel='Date time'
              className='mb-3'
              handleOnDateChange={(date, name) => handleOnDateChangeCategory(date, name, 'expense_other_reimbursement')}
              value={values?.expense_other_reimbursement?.datetime}
              feedbackInvalid={errors?.expense_other_reimbursement?.datetime}
              invalid={errors?.expense_other_reimbursement?.datetime}
            />
            <FormTextAreaInput
              id='description'
              name='description'
              colSize='6'
              inputLabel='Description'
              className='mb-3'
              placeholder='Enter description...'
              rows='6'
              value={values?.expense_other_reimbursement?.description}
              handleTextAreaInput={(e) => handleChangeFieldCategory(e, 'expense_other_reimbursement')}
              feedbackInvalid={errors?.expense_other_reimbursement?.description}
              invalid={errors?.expense_other_reimbursement?.description}
            />
          </CRow>
        )
      }
    </>
  )
}

export default AppForm